export const REQUIRED_TEST_GROUP_PERMISSIONS = [
  'iam.groups.delete',
  'iam.groups.list-members',
  'iam.groups.update',
  'iam.groups.update-members',
];

export const ROLE_TABLE_TYPES = {
  ORGANIZATION_PLATFORM: 'ORGANIZATION_PLATFORM',
  ORGANIZATION_SECRETS: 'ORGANIZATION_SECRETS',
  PROJECT_PLATFORM: 'PROJECT_PLATFORM',
  PROJECT_SECRETS: 'PROJECT_SECRETS',
  PROJECT_SECRETS_INTEGRATIONS: 'PROJECT_SECRETS_INTEGRATIONS',
  APPLICATION_SECRETS: 'APPLICATION_SECRETS',
};
